import { Fragment } from 'react'
import AppStyleDecider from '../../../../../../../../../../baseComponents/AppsStyleDecider'
import { OrderStepButtonsBaseComponentProps } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent/types'
import AdjustmentDeliveryNoteStatusBar, { AdjustmentDeliveryNoteStatusBarNew, DeliveryNoteCreateStatusBarProps } from '../../../AdjustmentDNStatusBar'
import AdjustmentDeliveryNoteFinishedStepButtons, { AdjustmentDeliveryNoteFinishedStepButtonsNew } from '../AdjustmentDNFinishedStepButtons'

type AdjustmentDeliveryNoteFinishedStepHeaderProps = & DeliveryNoteCreateStatusBarProps & OrderStepButtonsBaseComponentProps

const AdjustmentDeliveryNoteFinishedStepHeaderDecider: React.FC<AdjustmentDeliveryNoteFinishedStepHeaderProps> = ({ ...rest }) => {
    return (
        <AppStyleDecider DefaultComponent={AdjustmentDeliveryNoteFinishedStepHeaderDefault} NewComponent={AdjustmentDeliveryNoteFinishedStepHeaderNew} {...rest} />
    )
}

const AdjustmentDeliveryNoteFinishedStepHeaderDefault: React.FC<AdjustmentDeliveryNoteFinishedStepHeaderProps> = ({ ...rest }) => {
    return (
        <div className='flex gap-10 justify-between flex-wrap items-center flex-auto'>
            <AdjustmentDeliveryNoteStatusBar {...rest} />
            <AdjustmentDeliveryNoteFinishedStepButtons {...rest} />
        </div>
    )
}

const AdjustmentDeliveryNoteFinishedStepHeaderNew: React.FC<AdjustmentDeliveryNoteFinishedStepHeaderProps> = ({ ...rest }) => {
    return (
        <Fragment>
            <AdjustmentDeliveryNoteStatusBarNew {...rest} />
            <AdjustmentDeliveryNoteFinishedStepButtonsNew {...rest} />
        </Fragment>
    )
}

export default AdjustmentDeliveryNoteFinishedStepHeaderDecider